import React from 'react';
import classNames from 'classnames';

type Props = {
    /**
     * Classname for the wrapper around the content
     */
    contentClassName?: string;
    /**
     * The content in the topmost position of the wrapper, in another container than the children
     */
    titleContent?: React.ReactNode;
    /**
     * Classname for the title container
     */
    titleClassName?: string;
    /**
     * Items at the bottom of the wrapper, in another container than the children
     */
    footerContent?: React.ReactNode;
    /**
     * Classname for the wrapper at the bottom
     */
    footerClassName?: string;
    /**
     * hide background, removes the background and makes the element span the whole container
     * @default false
     */
    hideBackground?: boolean;
    /**
     * Render the content wrapper as something
     * @default "div"
     */
    contentWrapperAs?: React.ElementType;
} & React.PropsWithoutRef<JSX.IntrinsicElements['section']>;

const ListPanelWrapper: React.FC<Props> = ({
    className,
    children,
    contentClassName,
    titleContent,
    titleClassName,
    footerContent,
    footerClassName,
    hideBackground = false,
    contentWrapperAs,
    ...rest
}) => {
    const ContentWrapper = contentWrapperAs ?? 'div';
    return (
        <section
            className={classNames('sgw-list-panel__wrapper', className, {
                'hide-background': hideBackground,
                'has-footer': !!footerContent,
            })}
            {...rest}
        >
            {titleContent && (
                <div className={classNames('sgw-list-panel__wrapper--title', titleClassName)}>{titleContent}</div>
            )}
            <ContentWrapper className={classNames('sgw-list-panel__wrapper--content', contentClassName)}>
                {children}
            </ContentWrapper>
            {footerContent && (
                <div className={classNames('sgw-list-panel__wrapper--footer', footerClassName)}>{footerContent}</div>
            )}
            <div className={classNames('sgw-list-panel__background', { 'has-title': !!titleContent })} />
        </section>
    );
};

export default ListPanelWrapper;
